import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import logo from '../assets/logo.png';

const COD_REPARADOR = '9.254';

const s = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 9,
    color: '#111',
    paddingTop: 16,
    paddingBottom: 28,
    paddingHorizontal: 28,
  },

  // ── Cabecera ──────────────────────────────────────────
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  logo: { width: 110, height: 41 },
  codBox: {
    borderWidth: 1,
    borderColor: '#111',
    paddingVertical: 4,
    paddingHorizontal: 9,
    alignItems: 'center',
  },
  codLabel: { fontSize: 7, fontFamily: 'Helvetica-Bold', letterSpacing: 0.5 },
  codValor: { fontSize: 13, fontFamily: 'Helvetica-Bold', marginTop: 1 },

  // ── Fila genérica de campos ────────────────────────────
  fila: { flexDirection: 'row', marginBottom: 5, gap: 14 },
  campo: { flex: 1 },
  campoLabel: {
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
    textTransform: 'uppercase',
    marginBottom: 1,
  },
  campoLinea: {
    borderBottomWidth: 1,
    borderBottomColor: '#111',
    paddingBottom: 1,
    minHeight: 12,
    fontSize: 9,
  },
  campoLineaNegrita: {
    borderBottomWidth: 1.5,
    borderBottomColor: '#111',
    paddingBottom: 1,
    minHeight: 12,
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
  },

  // ── Fila inline (label + valor en la misma línea) ─────
  inlineFila: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
  },
  inlineLabel: {
    fontSize: 7.5,
    fontFamily: 'Helvetica-Bold',
    marginRight: 4,
    whiteSpace: 'nowrap',
  },
  inlineValorLinea: {
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#111',
    paddingBottom: 1,
    fontSize: 9,
    minHeight: 12,
  },
  inlineValorCuadrado: {
    flex: 1,
    borderWidth: 1.5,
    borderColor: '#111',
    paddingHorizontal: 5,
    paddingVertical: 2,
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
  },

  // ── Tabla de trabajos ─────────────────────────────────
  tabla: { marginBottom: 8 },
  cabecera: {
    flexDirection: 'row',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#111',
    paddingVertical: 3,
    backgroundColor: '#f0f0f0',
  },
  th: {
    fontSize: 7.5,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
  },
  fila_td: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#bbb',
    paddingVertical: 3,
    minHeight: 15,
  },
  td:     { fontSize: 8.5, textAlign: 'center' },
  tdUbic: { fontSize: 8.5 },

  colTarifa:  { width: '12%' },
  colTechos:  { width: '11%' },
  colParedes: { width: '11%' },
  colSup:     { width: '12%' },
  colPiso:    { width: '14%' },
  colUbic:    { width: '40%' },

  filaTotal: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    borderTopWidth: 1,
    borderTopColor: '#111',
    paddingTop: 3,
    marginTop: 1,
  },
  totalLabel: { fontSize: 8, fontFamily: 'Helvetica-Bold', marginRight: 4 },
  totalValor: { fontSize: 8, fontFamily: 'Helvetica-Bold', width: '12%', textAlign: 'center' },

  // ── Observaciones ─────────────────────────────────────
  obsLabel: {
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
    textTransform: 'uppercase',
    marginBottom: 3,
  },
  obsLinea: {
    borderBottomWidth: 0.75,
    borderBottomColor: '#111',
    marginBottom: 8,
    height: 11,
  },

  // ── Perito + Conforme ─────────────────────────────────
  bloqueInferior: { marginTop: 4 },
  filaConforme: {
    flexDirection: 'row',
    marginTop: 12,
    gap: 16,
  },
  conformeLabel: {
    fontSize: 7,
    fontFamily: 'Helvetica-Bold',
    textTransform: 'uppercase',
    marginBottom: 1,
  },
  conformeLinea: {
    borderBottomWidth: 1,
    borderBottomColor: '#111',
    minHeight: 50,
  },
});

const fmtFecha = (d) => {
  if (!d) return '';
  return new Date(d).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

function CampoFormulario({ label, valor = '', flex = 1, negrita = false }) {
  return (
    <View style={[s.campo, { flex }]}>
      <Text style={s.campoLabel}>{label}</Text>
      <Text style={negrita ? s.campoLineaNegrita : s.campoLinea}>{valor}</Text>
    </View>
  );
}

// Label + valor en la misma línea; cuadrado=true pone borde alrededor del valor
function CampoInline({ label, valor = '', flex = 1, cuadrado = false }) {
  return (
    <View style={[s.inlineFila, { flex }]}>
      <Text style={s.inlineLabel}>{label}:</Text>
      <Text style={cuadrado ? s.inlineValorCuadrado : s.inlineValorLinea}>{valor}</Text>
    </View>
  );
}

function FilaPerjudicado({ p }) {
  const telefonos = [p.telefono1, p.telefono2].filter(Boolean).join(' / ');
  return (
    <View style={[s.fila, { marginBottom: 4 }]}>
      <View style={[s.inlineFila, { flex: 3 }]}>
        <Text style={s.inlineLabel}>PERJUDICADO:</Text>
        <Text style={s.inlineValorLinea}>{p.perjudicado || ''}</Text>
      </View>
      <View style={[s.inlineFila, { flex: 1 }]}>
        <Text style={s.inlineLabel}>TELEF.:</Text>
        <Text style={s.inlineValorLinea}>{telefonos}</Text>
      </View>
    </View>
  );
}

export default function ParteTrabajosPdf({ siniestro, perjudicados, partes }) {
  const superficieTotal = partes.reduce((acc, p) => acc + (Number(p.superficie) || 0), 0);
  const nSiniestroTexto = siniestro.extension > 1
    ? `${siniestro.nSiniestro} Ext.${siniestro.extension}`
    : (siniestro.nSiniestro || '');

  // Al menos 1 fila de perjudicado aunque esté vacía
  const listaPerjudicados = perjudicados.length > 0 ? perjudicados : [{}];

  return (
    <Document title={`Parte de Trabajo — ${siniestro.nSiniestro}`}>
      <Page size="A4" style={s.page}>

        {/* ── Cabecera: logo + cod. reparador ── */}
        <View style={s.header}>
          <Image src={logo} style={s.logo} />
          <View style={s.codBox}>
            <Text style={s.codLabel}>COD. REPARADOR</Text>
            <Text style={s.codValor}>{COD_REPARADOR}</Text>
          </View>
        </View>

        {/* ── Nº Póliza + Nº Siniestro (inline, siniestro en cuadrado) ── */}
        <View style={[s.fila, { marginBottom: 6, alignItems: 'center' }]}>
          <CampoInline label="Nº PÓLIZA"    valor={siniestro.codPoliza || ''} flex={1} />
          <CampoInline label="Nº SINIESTRO" valor={nSiniestroTexto}           flex={1} cuadrado />
        </View>

        {/* ── Cliente + Teléfono ── */}
        <View style={s.fila}>
          <CampoFormulario label="CLIENTE"  valor={siniestro.titular}   flex={3} />
          <CampoFormulario label="TELEF."   valor={siniestro.telefono1} flex={1} />
        </View>

        {/* ── Perjudicados (uno por línea, N perjudicados) ── */}
        {listaPerjudicados.map((p, i) => (
          <FilaPerjudicado key={p.id ?? i} p={p} />
        ))}

        {/* ── Domicilio ── */}
        <View style={s.fila}>
          <CampoFormulario label="DOMICILIO" valor={siniestro.domicilio} />
        </View>

        {/* ── Localidad + Fecha asignación ── */}
        <View style={s.fila}>
          <CampoFormulario label="LOCALIDAD"     valor={siniestro.localidad}              flex={3} />
          <CampoFormulario label="F. ASIGNACIÓN" valor={fmtFecha(siniestro.fechaAsignacion)} flex={1} />
        </View>

        {/* ── Tabla de trabajos (solo filas con datos) ── */}
        <View style={s.tabla}>
          <View style={s.cabecera}>
            <Text style={[s.th, s.colTarifa]}>COD.TARIFA</Text>
            <Text style={[s.th, s.colTechos]}>TECHOS</Text>
            <Text style={[s.th, s.colParedes]}>PAREDES</Text>
            <Text style={[s.th, s.colSup]}>SUPERFICIE</Text>
            <Text style={[s.th, s.colPiso]}>PISO</Text>
            <Text style={[s.th, s.colUbic]}>TIPO/UBICACIÓN</Text>
          </View>

          {partes.map((p) => (
            <View key={p.id} style={s.fila_td} wrap={false}>
              <Text style={[s.td, s.colTarifa]}>{p.cTarifa || ''}</Text>
              <Text style={[s.td, s.colTechos]}>{p.techos || ''}</Text>
              <Text style={[s.td, s.colParedes]}>{p.paredes || ''}</Text>
              <Text style={[s.td, s.colSup]}>
                {p.superficie != null ? Number(p.superficie).toFixed(2) : ''}
              </Text>
              <Text style={[s.td, s.colPiso]}>{p.piso || ''}</Text>
              <Text style={[s.tdUbic, s.colUbic]}>{p.ubicacion || ''}</Text>
            </View>
          ))}

          <View style={s.filaTotal}>
            <Text style={s.totalLabel}>SUPERFICIE TOTAL:</Text>
            <Text style={s.totalValor}>{superficieTotal.toFixed(2)} m²</Text>
          </View>
        </View>

        {/* ── Observaciones (1 línea) ── */}
        <Text style={s.obsLabel}>OBSERVACIONES:</Text>
        <View style={s.obsLinea} />

        {/* ── Perito + Teléfono ── */}
        <View style={[s.fila, s.bloqueInferior]}>
          <CampoFormulario label="PERITO"  valor={siniestro.perito}      flex={3} />
          <CampoFormulario label="TELEF."  valor={siniestro.peritoMovil} flex={1} />
        </View>

        {/* ── D.N.I. + Conforme ── */}
        <View style={s.filaConforme}>
          <View style={{ flex: 2 }}>
            <Text style={s.conformeLabel}>D.N.I.</Text>
            <View style={s.conformeLinea} />
          </View>
          <View style={{ flex: 2 }}>
            <Text style={s.conformeLabel}>CONFORME:</Text>
            <View style={s.conformeLinea} />
          </View>
        </View>

      </Page>
    </Document>
  );
}
